<div class="chart card">
    <div class="chart__header">
        <div class="chart__header__titles">
            <h3 class="card-title-bold">{{ title }}</h3>
            <h3 class="card-title-light">Income and Expenses</h3>
        </div>
        <div 
            *ngIf="showSwitcher"
            class="chart__header__switcher card">
            <button 
                *ngFor="let option of DATES_OPTIONS"
                [class.active]="option.key === activeDateOption.key"
                (click)="selectDateOption(option)"
                class="chart__header__switcher__item icon-btn">
                {{ option.name }}
            </button>
        </div>
    </div>
    <div class="chart__data">
        <div class="chart__data__item">
            <span class="gradient-image blue-gradient income">
                <img 
                    src="./assets/images/dealer-dashboard/credit-card.svg" 
                    alt="Credit Card Icon">
            </span>
            <div class="chart__data__item__text">
                <p class="title">
                    Income
                </p>
                <p class="value">
                    $26,201
                    <span class="value__count rize">
                        10%
                        <img 
                            src="./assets/images/dealer-dashboard/rize.svg" 
                            alt="Up Arrow Icon">
                    </span>
                </p>
            </div>
        </div>
        <div class="chart__data__item">
            <span class="gradient-image green-gradient profit">
                <img 
                    src="./assets/images/dealer-dashboard/credit-card.svg" 
                    alt="Credit Card Icon">
            </span>
            <div class="chart__data__item__text">
                <p class="title">
                    Profit
                </p>
                <p class="value">
                    $18,120
                    <span class="value__count decrease">
                        10%
                        <img 
                            src="./assets/images/dealer-dashboard/decrease.svg" 
                            alt="Up Arrow Icon">
                    </span>
                </p>
            </div>
        </div>
    </div>
    <p-chart 
        type="line" 
        [data]="chartData" 
        [options]="chartOptions"
        [height]="'350px'"
    ></p-chart>
</div>